var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecosphere-container wrap"},[_vm._m(0),_c('div',{staticClass:"partner"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"partner-item"},[_c('img',{attrs:{"src":_vm.baseURL+item.partnerPic,"alt":""}})])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-title"},[_c('div',{staticClass:"title"},[_vm._v("企业合作伙伴")])])
}]

export { render, staticRenderFns }